import React, { useEffect, useState } from 'react';
import { Spinner } from '../../../components/common';
import { billingFiles } from '../../../services/billingFiles';
import { getApiError } from '../../../services/cmsService';

/**
 * The invoice PDF in an <iframe>, fetched with the bearer token. Change
 * `version` to refetch (after a payment or cancel the server regenerates it).
 */
const InvoicePdfFrame = ({ invoiceId, version = 0, className = '' }) => {
  const [url, setUrl] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!invoiceId) return undefined;
    let objectUrl = null;
    let cancelled = false;

    setError('');
    setUrl(null);
    billingFiles
      .pdfUrl(invoiceId)
      .then((next) => {
        if (cancelled) {
          URL.revokeObjectURL(next);
          return;
        }
        objectUrl = next;
        setUrl(next);
      })
      .catch((err) => {
        if (!cancelled) setError(getApiError(err, 'Could not load the PDF'));
      });

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [invoiceId, version]);

  if (error) return <div className="bl-empty">{error}</div>;
  if (!url) {
    return (
      <div className="bl-center">
        <Spinner size="large" />
      </div>
    );
  }
  return <iframe className={`bl-pdf-frame ${className}`} src={url} title="Invoice PDF" />;
};

export default InvoicePdfFrame;
